<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.webpage_heading" [ttModel]="setting.webpage_heading"></tt-page-heading>
    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
